;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

const updateMe = gql`
  mutation updateMe(
    $firstName: String
    $lastName: String
    $photoUrl: String
    $preferredName: String
    $preferredFirstName: String
    $preferredLastName: String
  ) {
    updateMe(
      input: {
        me: {
          firstName: $firstName
          lastName: $lastName
          photoUrl: $photoUrl
          preferredName: $preferredName
          preferredFirstName: $preferredFirstName
          preferredLastName: $preferredLastName
        }
      }
    ) {
      user {
        id
        firstName
        lastName
        photoUrl
        preferredName
        preferredFirstName
        preferredLastName
      }
    }
  }
`
export default updateMe
